import { Dispatch } from "redux";
import { setLoading, setLoadingModal } from "./global";
import { showMessage } from "utilities/helper";
import UserService from "service/User";
import { UserPayloadTypes } from "utilities/types/User";

export const getAllUsers =
  (page: number = 1, search: string = "", limit: number = 10) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_USER_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_USER",
      searchValue: search,
    });

    try {
      const data = await UserService.getAllUsers(page, search, limit);

      dispatch(setLoading(false));
      dispatch({ type: "SET_USER", value: data.users });
      dispatch({
        type: "SET_USER_PAGE",
        totalPage: !!data.users.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.users.length ? data.total_data : 1,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getUser = (userId: string) => async (dispatch: Dispatch) => {
  dispatch(setLoadingModal(true));

  try {
    const data = await UserService.getUser(userId);
    console.log(data);
    dispatch({ type: "SET_USER_DETAIL", value: data.user });
    dispatch(setLoadingModal(false));
  } catch (err: any) {
    dispatch(setLoadingModal(false));
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const storeUser =
  (form: UserPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await UserService.storeUser(payload);
      const { currentPage, searchValue, limitPage } = getState().userReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllUsers(currentPage, searchValue, limitPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateUser =
  (userId: string, form: UserPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await UserService.updateUser(userId, payload);
      const { currentPage, searchValue, limitPage } = getState().userReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllUsers(currentPage, searchValue, limitPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteUser =
  (userId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await UserService.deleteUser(userId);
      const { currentPage, searchValue, limitPage } = getState().userReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllUsers(currentPage, searchValue, limitPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
